import React, { Component } from 'react'
import ClassNames from 'classnames'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'react-chartjs-2'
import { BarChartStyle } from './styled'
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  ChartDataLabels
)

export class BarChart extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tooltipLabel: '',
    }
  }

  componentDidMount() {
    this.tooltipOnLabel()
  }

  pointerScales = (canvas, mousemove, datas, tooltip) => {
    let coordinates = canvas.getBoundingClientRect()
    var XAxis = mousemove.clientX - coordinates.left
    var YAxis = mousemove.clientY - coordinates.top
    let averageWidth = coordinates.width / datas.length
    let tooltipArr = []

    for (let index = 0; index < datas.length; index++) {
      if (index == 0) {
        tooltipArr.push({
          id: index,
          width: averageWidth,
          halfWidth: averageWidth / 2,
        })
      } else {
        tooltipArr.push({
          id: index,
          width: averageWidth + averageWidth * index,
          halfWidth: averageWidth + averageWidth * index - averageWidth / 2,
        })
      }
    }

    if (XAxis > 0 && YAxis > coordinates.height * 0.9) {
      const result = tooltipArr.find(e => e.width > XAxis)
      tooltip.style.display = 'block'
      tooltip.style.left = (result.halfWidth / coordinates.width) * 100 + '%'
      this.setState({ tooltipLabel: datas[result.id].label })
    } else {
      tooltip.style.display = 'none'
      this.setState({ tooltipLabel: '' })
    }
  }

  tooltipOnLabel = () => {
    const { datas, id } = this.props
    const chart = document.getElementById('chart-' + id)
    const tooltip = document.getElementById('tooltip-' + id)
    chart.addEventListener('mousemove', e => {
      this.pointerScales(chart, e, datas, tooltip)
    })
    chart.addEventListener('mouseout', () => {
      tooltip.style.display = 'none'
      this.setState({ tooltipLabel: '' })
    })
  }

  render() {
    const { datas, fullScore, highScore, lowScore, title, id } = this.props
    let labels = []
    let pointtopchart = []
    let value = []
    let chartcolor = []

    for (let index = 0; index < datas.length; index++) {
      pointtopchart.push(0)
      labels.push(datas[index].label)
      value.push(parseFloat(datas[index].value))

      if (parseFloat(datas[index].value) > highScore) {
        chartcolor.push('#16A651')
      } else if (
        parseFloat(datas[index].value) <= highScore &&
        parseFloat(datas[index].value) > lowScore
      ) {
        chartcolor.push('#FFB60F')
      } else if (parseFloat(datas[index].value) <= highScore) {
        chartcolor.push('#E24132')
      } else {
        chartcolor.push('black')
      }
    }

    const labeltooltip = tooltipItem => {
      return ''
    }

    const data = {
      labels,
      datasets: [
        {
          data: value,
          backgroundColor: chartcolor,
          borderRadius: 15,
          borderWidth: 0,
          scaleFontColor: '#FFFFFF',
          datalabels: {
            backgroundColor: '#4b4acb',
            borderRadius: 5,
            padding: 8,
            display: true,
            color: 'white',
            anchor: 'end',
            align: 'start',
            formatter: function (value, context) {
              return datas[context.dataIndex].value
            },
            offset: function (context) {
              var width = context.chart.width
              var result = -50
              if (width > 450) {
                result = -50
              } else if (width <= 450 && width > 400) {
                result = -45
              } else if (width <= 400 && width > 350) {
                result = -40
              } else if (width <= 350 && width > 300) {
                result = -35
              } else if (width <= 300) {
                result = -30
              } else {
                result = -25
              }
              return result
            },
            font: function (context) {
              var width = context.chart.width
              var size = Math.round(width / 32)

              return {
                size: size,
              }
            },
          },
        },
        {
          data: pointtopchart,
          datalabels: {
            backgroundColor: 'white',
            borderRadius: 100,
            textAlign: 'center',
            font: function (context) {
              var width = context.chart.width
              var size = Math.round(width / 32)

              return {
                size: size,
                lineHeight: 0.5,
              }
            },
            padding: 2,
            color: '#E3EBF0',
            align: 'center',
            anchor: 'end',
            climp: false,
            formatter: function (value, context) {
              return '●'
            },
          },
        },
      ],
    }

    const options = {
      animation: false,
      responsive: true,
      hover: { mode: null },
      plugins: {
        tooltip: {
          enabled: false,
          displayColors: false,
          titleMarginBottom: 0,
          yAlign: 'top',
          callbacks: {
            label: labeltooltip,
          },
          titleFont: function (context) {
            var width = context.chart.width
            var size = Math.round(width / 32)

            return {
              weight: 'bold',
              size: size,
            }
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
          },
          ticks: {
            color: '#4b4acb',
            font: function (context) {
              var width = context.chart.width
              var size = Math.round(width / 32)

              return {
                size: size,
              }
            },
            callback: function (label) {
              const fullLabel = this.getLabelForValue(label) + ''
              // console.log(fullLabel.length)
              var newLabel = ''
              if (fullLabel.length > 15) {
                newLabel = fullLabel.substring(0, 13) + '...'
              } else {
                newLabel = fullLabel
              }
              return newLabel
            },
          },
        },
        y: {
          stacked: true,
          grid: {
            display: false,
            drawTicks: false,
            drawBorder: false,
          },
          ticks: {
            display: false,
            stepSize: 40,
          },
        },
      },
      layout: {
        padding: {
          top: 50,
        },
      },
    }

    return (
      <BarChartStyle id={id}>
        <div className="distribution">
          <div className="title">{title}</div>
          <div className="chart-wrapper">
            <div className="chart">
              <Bar id={`chart-${id}`} options={options} data={data} />
            </div>
            <div className="tooltip-container">
              <div id={`tooltip-${id}`} className="tool-tip">
                <p>{this.state.tooltipLabel}</p>
              </div>
            </div>
          </div>
          <div className="footer">
            {fullScore && (
              <div className="full-score">Full Score : {fullScore}</div>
            )}

            <div className="high-risk">
              <div className="box-red"></div>
              High : 0-{lowScore} %
            </div>
            <div className="medium-risk">
              <div className="box-yellow"></div>
              Medium : &gt;{lowScore}-{highScore} %
            </div>
            <div className="low-risk">
              <div className="box-green"></div>
              Low : &gt;{highScore} %
            </div>
          </div>
        </div>
      </BarChartStyle>
    )
  }
}
